import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { IoSearch } from "react-icons/io5";
import { Table, Pagination } from "react-bootstrap";
import { TiArrowSortedUp, TiArrowSortedDown } from "react-icons/ti";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import { IoClose } from "react-icons/io5";
import sort from "../../assets/sort.svg";
import pdf from "../../assets/pdf.svg";
import Popup from "reactjs-popup";
import { createCustomers, customersDetails, customersReportPdf } from "../../services/ApiServices";
import ToastMsg from "../../component/comman/ToastMsg";
import { Link } from 'react-router-dom';
import filter from "../../assets/filter.svg";

var transaction_type = ""
var order = ""

function Customer() {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [open, setOpen] = useState(false);
  const closeModal = () => setOpen(false);
  const [customers, setCustomers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [pageInfo, setPageInfo] = useState({
    current_page: 1,
    total_pages: 1,
    has_next: false,
    has_previous: false,
  });
  const [formData, setFormData] = useState({
    company: "1",
    name: "",
    phone: "",
    email: "",
    details: "",
  });


  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  function downloadBase64Pdf(base64String, fileName = "customers_report.pdf") {
    try {
      const cleanedBase64String = base64String.replace(/^data:application\/pdf;base64,/, "");
      console.log(cleanedBase64String)
      const byteCharacters = atob(cleanedBase64String);
      const byteNumbers = Array.from(byteCharacters, char => char.charCodeAt(0));
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/pdf" });

      const blobUrl = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName;

      link.click();

      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Failed to download PDF:", error.message);
    }
  }

  const getCustomerReport = useCallback(() => {
    var queryParams = { name: searchTerm, page_num: currentPage, per_page_data: itemsPerPage, is_pdf: true };
    if (transaction_type != "") {
      queryParams["transaction_type"] = transaction_type
    }
    if (order != "") {
      queryParams["order"] = order
    }
    customersReportPdf(queryParams)
      .then((res) => {
        console.log("API Response:", res.data);
        downloadBase64Pdf(res.data.pdf_base64)
        console.log(res.pdf_base64)

      })
      .catch((err) => {
        console.error("API Error:", err);
        let error = err?.response?.data?.error || "something went wrong";
        ToastMsg(error, "error");
      });
  })

  const getCustomersDetails = useCallback((params = {}) => {
    var queryParams = { ...params, name: searchTerm, page_num: currentPage, per_page_data: itemsPerPage };
    if (transaction_type != "") {
      queryParams["transaction_type"] = transaction_type
    }
    if (order != "") {
      queryParams["order"] = order
    }
    customersDetails(queryParams)
      .then((res) => {
        console.log("API Response:", res.data.data);
        if (res.status === 200 && Array.isArray(res?.data?.data)) {
          setCustomers(res?.data?.data);
          setFilteredCustomers(res?.data?.data);
          setPageInfo(res?.data?.page_info);
          setTotalPages(res?.data?.page_info.total_pages);
        } else {
          setCustomers([]);
          setFilteredCustomers([]);
        }
      })
      .catch((err) => {
        console.error("API Error:", err);
        if (err.response?.status === 401) {
          navigate("/");
        }
        let error = err?.response?.data?.error || "something went wrong";
        ToastMsg(error, "error");
        setCustomers([]);
        setFilteredCustomers([]);
      });
  }, [navigate, searchTerm, currentPage, itemsPerPage]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      getCustomersDetails();
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm, getCustomersDetails]);

  useEffect(() => {
    setFilteredCustomers(customers);
    setTotalPages(Math.ceil(customers.length / itemsPerPage));
  }, [customers, itemsPerPage]);

  const handleSort = (sortOrder) => {
    order = sortOrder
    getCustomersDetails();
  };

  useEffect(() => {
    getCustomersDetails();
  }, [getCustomersDetails, currentPage, itemsPerPage,]);

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const isValidPhone = (phone) => {
    return phone.toString().length === 10;
  };

  const isFormValid = () => {
    return (
      formData.name.trim() &&
      isValidPhone(formData.phone) &&
      isValidEmail(formData.email) &&
      formData.details.trim()
    );
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({
      ...formData,
      [id]: value,
    });
  };
  const handleAccounts = (sortOrder) => {
    transaction_type = sortOrder
    const params = {};
    getCustomersDetails(params);
  };
  const handleCustomerData = () => {
    const customerData = {
      company: 1,
      name: formData.name,
      email: formData.email,
      mobile_no: formData.phone,
      details: formData.details,
    };

    createCustomers(customerData).then((res) => {
      closeModal();
      getCustomersDetails();
      setFormData({
        company: "1",
        name: "",
        phone: "",
        email: "",
        details: "",
      });
      console.log(res);
      ToastMsg(res?.data?.message, "success");
    })
      .catch((err) => {
        if (err.response?.status === 401) {
          window.location.href = "/";
        }
        let error = err?.response?.data?.error || "something went wrong";
        ToastMsg(error, "error");
      });
  };

  return (
    <>
      <div className="dasboard-content">
        <div className="card mb-4">
          <div className="card-body">
            <div className="search-sc d-flex align-items-center justify-content-between">
              <form>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                  <IoSearch className="search-icon" />
                </div>
              </form>
              <button className="btn" onClick={() => setOpen((o) => !o)}>
                + New Account
              </button>
            </div>
          </div>
        </div>
        <div className="card mb-4">
          <div className="card-body">
            <div className="card-header d-flex align-items-center justify-content-end">
              <div className="filter d-flex align-items-center">
                <div style={{ cursor: "pointer" }} className="link d-flex align-items-center" onClick={() => getCustomerReport()}>
                  <img src={pdf} alt="icon" width={24} height={21} />
                  <span>Export PDF</span>
                </div>
                <div className="dropdown">
                  <button className="flex align-items-center">
                    <span>Sort</span>
                    <img src={sort} alt="icon" width={18} height={15} />
                  </button>
                  <div className="subMenu">
                    <ul>
                      <li onClick={() => handleSort("id")}>Id <TiArrowSortedDown /></li>
                      <li onClick={() => handleSort("-id")}>Id <TiArrowSortedUp /></li>
                      <li onClick={() => handleSort("name")}>Name <TiArrowSortedDown /></li>
                      <li onClick={() => handleSort("-name")}>Name <TiArrowSortedUp /></li>
                      <li onClick={() => handleSort("balance")}>Balance <TiArrowSortedDown /></li>
                      <li onClick={() => handleSort("-balance")}>Balance <TiArrowSortedUp /></li>
                    </ul>
                  </div>
                </div>
                <div className="dropdown" style={{ marginLeft: "10px" }}>
                  <button className="flex align-items-center">
                    <span>Accounts</span>
                    <img src={filter} alt="icon" width={18} height={15} />
                  </button>
                  <div className="subMenu">
                    <ul>
                      <li onClick={() => handleAccounts("")}>All</li>
                      <li onClick={() => handleAccounts("credit")}>Credit</li>
                      <li onClick={() => handleAccounts("debit")}>Debit</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="table-responsive table-web-customers">
              <Table className="table-centered table-striped table-hover mb-0">
                <thead className="table-light">
                  <tr>
                    <th style={{ cursor: "pointer", textAlign: "left", fontSize:"12px" }}>ID</th>
                    <th style={{ cursor: "pointer", textAlign: "left", fontSize:"12px" }}>Name</th>
                    {/* <th style={{ cursor: "pointer" }}>Email</th>
                    <th style={{ cursor: "pointer" }}>Phone Number</th> */}
                    <th style={{ cursor: "pointer", textAlign: "right", fontSize:"12px" }}><b>Balance</b></th>
                  </tr>
                </thead>
                <tbody>
                  {filteredCustomers.length === 0 ? (
                    <tr>
                      <td colSpan="5" className="text-center">
                        No Data Found
                      </td>
                    </tr>
                  ) : (
                    filteredCustomers.map((user, index) => (
                      <tr key={index} style={{cursor:"pointer"}} 
                          onClick={() => window.open(`/customer-transactions?userId=${user.id}&name=${user?.name}&company=${user?.company_id}`, '_blank')}>
                        <td style={{ textAlign: "left", fontWeight: 400, fontSize:"12px" }}>{user.id}</td>
                        <td style={{ textAlign: "left", fontWeight: 400, fontSize:"12px" }}>
                          <Link
                            to={`/customer-transactions?userId=${user.id}&name=${user?.name}&company=${user?.company_id}`}
                            className="text-decoration-none"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {user.name}
                          </Link>
                        </td>
                        {/* <td>{user.email}</td>
                        <td>{user.mobile_no}</td> */}
                        <td style={{ textAlign: "right", fontSize:"12px", fontWeight: 400, color: user.balance?.toString().startsWith('-') ? "red" : "#31A140", }}><b>€ {user.balance || 0}</b></td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            </div>
            <div className="d-flex justify-content-between align-items-center border-top pagination-wrapper">
              <div className="text-muted small">
                {(currentPage - 1) * itemsPerPage + 1}-
                {10 * (currentPage - 1) + filteredCustomers.length}
                {" "}of {pageInfo.total_data || "0"}
              </div>
              <div className="d-flex align-items-center">
                <div className="form-group d-flex align-items-center">
                  <label htmlFor="itemsPerPage">Rows per page:</label>
                  <select
                    id="itemsPerPage"
                    className="form-control"
                    value={itemsPerPage}
                    onChange={(e) => setItemsPerPage(Number(e.target.value))}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                  </select>
                  <MdOutlineKeyboardArrowDown />
                </div>
                <Pagination size="sm" className="pagination-rounded mb-0">
                  <Pagination.Prev
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  />
                  <p>
                    <span>{currentPage}</span>/{pageInfo.total_pages}
                  </p>
                  <Pagination.Next
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === pageInfo.total_pages}
                  />
                </Pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Popup
        open={open}
        closeOnDocumentClick={false}
        onClose={closeModal}
        className="new-user"
      >
        <div className="card">
          <div className="card-body">
            <div className="flex align-items-center justify-content-between">
              <h5>Create New Customer</h5>
              <IoClose onClick={closeModal} />
            </div>
            <form>
              <div className="form-group title-input">
                <label htmlFor="name">Full Name *</label>
                <div className="d-flex align-items-center">
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    value={formData.title}
                    onChange={(e) =>
                      setFormData({ ...formData, title: e.target.value })
                    }
                  >
                    <option value="1">Mr.</option>
                    <option value="2">Mrs.</option>
                  </select>
                  <input
                    type="text"
                    id="name"
                    className="form-control"
                    placeholder="Enter Full Name"
                    value={formData.name}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="phone">Mobile Number</label>
                <input
                  type="number"
                  id="phone"
                  className="form-control"
                  placeholder="Mobile Number"
                  value={formData.phone}
                  onChange={handleChange}
                />
                {formData.phone && !isValidPhone(formData.phone) && (
                  <small className="text-danger">
                    Please enter a valid 10-digit phone number.
                  </small>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  className="form-control"
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleChange}
                />
                {formData.email && !isValidEmail(formData.email) && (
                  <small className="text-danger">
                    Please enter a valid email address.
                  </small>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="details">Details</label>
                <textarea
                  className="form-control"
                  id="details"
                  rows="3"
                  value={formData.details}
                  onChange={handleChange}
                ></textarea>
              </div>
              <div className="button-wrapper btnPrimary text-right">
                <button
                  type="button"
                  className="btn"
                  onClick={handleCustomerData}
                >
                  Create Customer
                </button>
              </div>
            </form>
          </div>
        </div>
      </Popup>
    </>
  );
}

export default Customer;
